import Vue from 'vue';
import Router from 'vue-router';
import Welcome from '@/views/Welcome';
import Cover from '@/views/Cover';
import Market from '@/views/Market';
import Intro from '@/views/Intro';
import Benefits from '@/views/Benefits';
import Configurator from '@/views/Configurator';
import Mail from '@/views/Mail';

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Market',
      component: Market,
    },
    {
      path: '/cover',
      name: 'Cover',
      component: Cover,
    },
    {
      path: '/welcome',
      name: 'Welcome',
      component: Welcome,
    },
    {
      path: '/intro',
      name: 'Intro',
      component: Intro,
    },
    {
      path: '/benefits',
      name: 'Benefits',
      component: Benefits,
    },
    {
      path: '/configurator',
      name: 'Configurator',
      component: Configurator,
    },
    {
      path: '/mail',
      name: 'Mail',
      component: Mail,
    },
  ],
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
});



// WEBPACK FOOTER //
// ./src/router/index.js